import { Box, Flex } from '@mantine/core'
import { memo, type ChangeEvent } from 'react'

import { DateTimePickerInput } from '../../../DateTimePickerInput/DateTimePickerInput'

type DateTimeRangePickerProps = {
  onTimeChange: (event: ChangeEvent<HTMLInputElement>) => void
  onDateChange: (value: Date | null) => void
  timeValue: string | number
  showCalendarIcon?: boolean
  dateValue: Date | null
  error?: boolean
}

export const DateTimeRangePicker = memo(
  ({
    showCalendarIcon = false,
    onDateChange,
    onTimeChange,
    dateValue,
    timeValue,
    error = false,
  }: DateTimeRangePickerProps) => {
    const combinedValue =
      dateValue && typeof timeValue === 'string'
        ? `${dateValue.toISOString().split('T')[0]}T${timeValue}`
        : ''

    return (
      <Box w='100%'>
        <Flex w='inherit'>
          <DateTimePickerInput
            size='md'
            value={combinedValue}
            fullWidth
            error={error}
            onChange={(value: string) => {
              if (typeof value === 'string') {
                const [date, time] = value.split('T')
                if (date) {
                  onDateChange(new Date(date))
                }
                if (time) {
                  onTimeChange({
                    target: { value: time },
                  } as ChangeEvent<HTMLInputElement>)
                }
              }
            }}
            showCalendarIcon={showCalendarIcon}
          />
        </Flex>
      </Box>
    )
  }
)

DateTimeRangePicker.displayName = 'DateTimeRangePicker'
